import React, { Component } from "react";
import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import { ActionCreators } from "../actions";
import Paper from "@material-ui/core/Paper";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import WizardFormFirstPage from "./wizardSection/WizardFormFirstPage";
import WizardFormSecondPage from "./wizardSection/WizardFormSecondPage";
import WizardFormThirdPage from "./wizardSection/WizardFormThirdPage";
import WizardFormReviewPage from "./wizardSection/WizardFormReviewPage";
import WizardFormConfirmationPage from "./wizardSection/WizardFormConfirmationPage";
import WizardFormErrorPage from "./wizardSection/WizardFormErrorPage";

class FormNew extends Component {
  constructor(props) {
    super(props);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.state = {
      page: 1
    };
  }
  nextPage() {
    this.setState({ page: this.state.page + 1 });
  }

  previousPage() {
    this.setState({ page: this.state.page - 1 });
  }

  submitData = values => {
    const { submitForm, gaFormAction } = this.props;
    submitForm(values, response => {
      switch (response) {
        case "SUCCESS":
          this.setState(() => ({ page: 5 }));
          gaFormAction("Submitted Form", `CWD Sample: ${values.cwdCode}`);
          break;
        case "FAILED":
          this.setState(() => ({ page: 6 }));
          gaFormAction("Submit Error", `CWD Sample: ${values.cwdCode}`);
          break;
        default:
          break;
      }
    });
  };

  render() {
    const { page } = this.state;

    return (
      <Paper
        elevation={5}
        style={{
          margin: 10,
          marginTop: 20,
          paddingLeft: 25,
          paddingRight: 25,
          paddingBottom: 10
        }}
      >
        <AppBar style={{ marginBottom: 25 }} position="static">
          <Toolbar className="voluteer">
            <Typography variant="title" color="inherit">
              CWD Data Collection
            </Typography>
          </Toolbar>
        </AppBar>

        <div>
          {page === 1 && <WizardFormFirstPage onSubmit={this.nextPage} />}
          {page === 2 && (
            <WizardFormSecondPage
              previousPage={this.previousPage}
              onSubmit={this.nextPage}
            />
          )}
          {page === 3 && (
            <WizardFormThirdPage
              previousPage={this.previousPage}
              onSubmit={this.nextPage}
            />
          )}

          {page === 4 && (
            <WizardFormReviewPage
              previousPage={this.previousPage}
              onSubmit={this.submitData}
            />
          )}

          {page === 5 && <WizardFormConfirmationPage />}
          {page === 6 && <WizardFormErrorPage />}
        </div>
      </Paper>
    );
  }
}

export default reduxForm({
  form: "wizard"
})(
  connect(
    null,
    ActionCreators
  )(FormNew)
);



// WEBPACK FOOTER //
// ./src/components/FormNew.jsx